(function () {
  function init(root) {
    root.querySelectorAll('[data-ring-discovery]').forEach(function (section) {
      if (section.dataset.ringReady) return;
      section.dataset.ringReady = 'true';
      var filters = section.querySelectorAll('[data-ring-filter]');
      var cards = section.querySelectorAll('[data-ring-style]');
      var descriptions = section.querySelectorAll('[data-ring-description]');
      var status = section.querySelector('[data-ring-status]');
      var browse = section.querySelector('[data-ring-browse]');
      function selectStyle(style) {
        var count = 0;
        cards.forEach(function (card) {
          card.hidden = style !== 'all' && card.dataset.ringStyle !== style;
          if (!card.hidden) count += 1;
        });
        filters.forEach(function (button) {
          button.setAttribute('aria-pressed', String(button.dataset.ringFilter === style));
        });
        browse.href = '/collections/engagement-rings';
        browse.textContent = 'View all engagement rings';
        descriptions.forEach(function (description) {
          description.hidden = description.dataset.ringDescription !== style;
          description.open = false;
          if (!description.hidden) {
            browse.href = description.dataset.browseUrl || '/collections/engagement-rings';
            browse.textContent = description.dataset.browseLabel;
          }
        });
        status.textContent = count + (count === 1 ? ' design' : ' designs');
      }
      filters.forEach(function (button) {
        var style = button.dataset.ringFilter;
        button.hidden = style !== 'all' && !Array.from(cards).some(function (card) {
          return card.dataset.ringStyle === style;
        });
        button.addEventListener('click', function () { selectStyle(style); });
      });
      section.querySelector('.ring-discovery__styles').hidden = cards.length === 0;
      selectStyle('all');
      // Keep all editable product blocks reachable in the theme editor.
      section.addEventListener('shopify:block:select', function () { selectStyle('all'); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
